<template>
    <div id="all" class="all">
        <header>
            <van-cell :value="date" @click="show = true" title-class='titleclass'>
                <template #title>
                    <div class="van-new-cell-title">筛选</div>
                </template>
                <template #right-icon>
                    <div>
                        <van-icon class="icon" name="filter-o" size="1.4rem" />
                    </div>
                </template>
            </van-cell>
        </header>

        <van-calendar @cancel="onCancel" v-model="show2" type="range" @confirm="onConfirm" :min-date="minDate" />


        <van-popup v-model="show" round closeable position="right" :style="{ width: '60%', height: '100%' }">

            <van-cell-group style="margin-top:4rem;">
                <van-cell title-class='titleclass' @click="show1 = true" >
                    <template #title>
                        <div class="van-new-cell-title">人员类型：</div>
                    </template>
                    <template #right-icon>
                        <div v-if="form.perpleType">
                            {{ form.perpleType.text }}
                        </div>
                    </template>
                </van-cell>
                 <van-cell :value="date"  title-class='titleclass' @click="show2 = true" >
                    <template #title>
                        <div class="van-new-cell-title">值班日期：</div>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-popup>

         <van-popup v-model="show1" round  position="bottom" :style="{ height: '30%' }">
            <van-picker :columns="columns"
             title="人员类型"
            show-toolbar
             @cancel="onCancel"
            @change="onPickerChange"/>
         </van-popup>


        <div class='main'>
            <van-card v-for="(item, index) in list" :key="index" :desc="item.description" :title="item.summary"
                :class="item.templeId | classid">
                <template #title>
                    <div class="flex">
                        <div>{{ item.summary }}</div>
                        <div v-show=" item.createType == 1 && item.leaderName">
                            <van-tag plain  type="primary">
                               {{ item.leaderName }}
                            </van-tag>
                        </div>
                        <div v-show="item.createType">
                            <van-tag plain round type="primary">
                                {{ 
                                    item.createType == 1?"领导" : 
                                    item.createType == 4?"辅导员" :
                                    item.createType == 5?"保卫部" : "打酱油的" 
                                }}
                            </van-tag>
                          
                        </div>
                    </div>
                </template>
                <template #desc>
                    <div class="flex">
                        <div v-show="item.userName">{{ item.userName }}</div>
                        <div>{{ item.beginTime | datafilter }}</div>
                    </div>
                </template>
                <template #footer>
                    <div class="flex">
                        <div v-show="item.description">{{ item.description }}</div>
                    </div>
                </template>
                
              
            </van-card>
        </div>

        <van-pagination v-show="totalitems != 0" v-model="currentPage" :total-items="totalitems" :show-page-size="3"
            force-ellipses @change='changelist' />
    </div>
</template>
<script>
import { GetPageAsync } from "@/api/Scheduling/Scheduling";
import moment from "moment";
export default {
    name: "HistoryLog",
    data() {
        return {
            show: false,
            show1:false,
            show2:false,
            currentDate: new Date(),
            value: null,
            date: '',
            minDate: new Date(2022, 0, 1),
            currentPage: 1,
            totalitems: 0,
            list: [],
            stylename: null,
            datevalue: null,
            columns:[
                { text: '领导',value:'1'},
                { text: '保卫部',value:'5' },
                { text: '辅导员',value:'4' }
            ],
            form:{
                perpleType:null
            },
            queryForm: {
                beginTime: null,
                endTime: null,
                createTypes: [1, 4, 5],
                createtype: null,
            }
        }
    },
    filters: {
        classid: function (value) {
            return "templeId" + value;
        },
        datafilter: function (value) {
            console.log(value, moment(value).format("yyyy-MM-DD"));
            return moment(value).format("yyyy-MM-DD")
        }
    },
    methods: {
        /**
         * 筛选
         * @param {*} date
         */
        onPickerChange(e, value, index){
            console.log(e,value,index,'e');
            this.show1 = false;
            this.$set(this.form,'perpleType',value);

            this.$set(this.queryForm,'createTypes', [value.value]);

            this.getList(
                this.queryForm
            )
        },
        onCancel(){
            this.$set(this.queryForm,'createTypes', [1, 4, 5]);
            this.show2 = false;

        },
        onConfirm(date) {

            this.datevalue = date;
            const [start, end] = date;
            this.show2 = false;
            this.date = `${moment(start).format("MM/DD")} - ${moment(end).format("MM/DD")}`;
            this.$set(this.queryForm,'beginTime',moment(start).format("YYYY-MM-DD hh:mm:ss"));
            this.$set(this.queryForm,'endTime',moment(end).format("YYYY-MM-DD hh:mm:ss"));
            this.getList(
                this.queryForm
            )

        //    {
        //         beginTime: moment(start).format("YYYY-MM-DD hh:mm:ss"),
        //         endTime: moment(end).format("YYYY-MM-DD hh:mm:ss"),
        //         createTypes: [1, 4, 5],
        //         createtype: null,
        //     }
        },
        getList(data) {
            GetPageAsync(data).then(res => {
                this.list = res.items;
                this.totalitems = res.totalCount;
                let cssstr = ""
                for (var i of res.items) {
                    cssstr += `.templeId${i.templeId}{border-left:10px solid ${i.color}}`;
                }
                const style = document.createElement("style");
                style.type = "text/css";
                style.textContent = cssstr;
                document.getElementsByTagName("head").item(0).appendChild(style);
            })
        },
        changelist(e) {
            let obj = {
                beginTime: moment().add(-1, 'M').format("YYYY-MM-DD 00:00:00"),
                endTime: moment().add(1, 'D').add(-1, 'h').format("YYYY-MM-DD hh:mm:ss"),
                skipcount: 0,
                createTypes:this.queryForm.createTypes,
                createtype: null,
            }



            if (e >= 1) {
                obj.skipcount = (e - 1) * 10
            }
            if (this.datevalue) {
                const [start, end] = this.datevalue;
                obj.beginTime = moment(start).format("YYYY-MM-DD hh:mm:ss");
                obj.endTime = moment(end).format("YYYY-MM-DD hh:mm:ss");
            }

            this.getList(obj)
            // let SkipCount = e*10;
        }
    },
    mounted: async function () {
        await this.$store.dispatch("app/setActive", 4);
        this.getList({
            beginTime: moment().add(-1, 'M').format("YYYY-MM-DD 00:00:00"),
            endTime: moment().add(1, 'D').add(-1, 'h').format("YYYY-MM-DD hh:mm:ss"),
            createTypes: [1, 4, 5],
            createtype: null,
        });
    }

}
</script>
<style>
.van-card__content {
    min-height: auto !important;
}

.red {
    border-left: 5px solid red;
}

/* .van-cell{
    line-height: 3px !important;
    padding: 19px 16px !important;
} */
.van-cell__value {
    overflow: initial !important;
}

.all {
    overflow-y: auto;
}

.main {
    flex: 1;
    margin-bottom: 0.5rem;
}
</style>
<style lang="scss" scoped>
.titleclass {
    font-size: 12px;
}

.flex {
    display: flex;
    flex-direction: rows;
    justify-content: space-between;
}
</style>